import React from "react";
import { Row, Container, Col } from "react-bootstrap";
export default function AboutBanner(props) {
  return (
    <>
      
      <Row className="no-gutters pt-5" style={{ position: "relative" }}>
        {/* Adding custom image */}
         <img
          src={props.customImage}
          alt=""
          style={{
            width: "100%",
            height: "38vh",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: -1,
            opacity: 0.8,
          }}
        />
       
        <Container className="my-5">
          <Row>
            <Col sm="12" className="text-center mb-3">
            <h2 className="yellowColor" style={{ fontStyle: "italic",marginTop:"70px",fontWeight:"bold"}}>
  {props.heading}
</h2>

              
            </Col>
          </Row>
        </Container>
      </Row>
    </>
  );
}
